import * as React from 'react';

import './styles.scss';
import classNames from 'classnames';
import RenderHTML from '../RenderHTML';

export interface IControlSwitchProps {
    /** Label to display */
    label: string | React.ReactNode;
    /** Is label visible */
    isLabelVisible?: boolean;
    /** State of Checkbox */
    checked: boolean;
    /** Disabled status */
    disabled?: boolean;
    /** Change event */
    onChange: (event) => void;
    /** Error */
    hasError?: boolean;
    /** Checkbox wiggle on error */
    errorAnimated?: boolean;
    /** DOM target element name attribute */
    name?: string;
    /** DOM target element id attribute */
    id?: string;
    /** Value */
    value?: string;
    /** Description */
    description?: string;
    /** Data test id for automated tests */
    testId?: string;
}


const ControlSwitch: React.FunctionComponent<IControlSwitchProps> = (props) => {
    const {label, isLabelVisible, checked, id, name, value, disabled, onChange, description, hasError, errorAnimated} = props;
    return (
        <div className={classNames('control-switch', {
            'visible-label': isLabelVisible,
        })}>
            <label
                htmlFor={props.id}
            >
                <input type="checkbox"
                   checked={checked}
                   disabled={disabled}
                   onChange={onChange}
                   name={name}
                   id={id}
                   value={value}
                />
                <span className={classNames('control-switch-label', {
                    'has-error': hasError,
                    'error-animated': errorAnimated,
                })}>
                    {label}
                </span>
            </label>
            {!!description && (
                <div className="control-switch-description"><RenderHTML html={description} nowrapper={true} /></div>
            )}
        </div>
    );
};
ControlSwitch.displayName = 'ControlSwitch';

export default ControlSwitch;
